<template>
  <div class="page-parent products-page v1 secure">

    <section class="products-hero">
      <div class="title">

        <h1> <s-icon class="hero-icon secure-icon" circle icon-font="s-icon-lock"/><span class="s-text-green"> Private </span>and Secure</h1>

        <SButton class="button-secondary" btn-link="/signup">Try Now</SButton>
        <SButton class="button-fill button-primary" btn-link="https://www.seedr.cc/premium" icon-font="s-icon-premium">Join Premium</SButton>

      </div>
      <div class="image">
        <img src="/assets/images/home_security-2_v1.svg" alt="product page image" class="">
      </div>
    </section>

    <section class="products-details-parent" id="product-details">
      <div class="products-details-child title">
<!--        <img src="..//assets/images/icon_products_search_contextual.svg" alt="" class="">-->
        <h1>Download Files Stress-Free</h1>
        <h2>Our Service Keeps Your Data Safe and Private</h2>
      </div>

      <div class="products-details-child paragraph grey">

        <p>All our devices are online, and it is natural to be concerned about your data privacy and security. You want full reassurance that your personal information is safe when browsing the web and downloading files. The last thing you need is stress over who can access your sensitive data or how it's protected.</p>

        <p>Fortunately, our service utilizes a secure cloud downloading process that protects your privacy from start to finish. By handling downloads remotely on our servers instead of locally on your device, your information stays safe. You also enjoy hands-free automated downloading.</p>

        <p>Read on to see how our approach delivers a stress-free file downloading experience with complete peace of mind.</p>
      </div>
      <div class="products-details-child paragraph grey">
        <h2>The Risks of Normal Downloading</h2>

        <p>Typically when you download something from the internet, it saves directly to your computer or phone hard drive. This local saving method comes with many potential privacy and security risks:</p>

        <ul>
          <li>Tracking cookies can monitor your browsing history and download activity when files are saved locally. This allows third parties to build profiles about your interests and habits without consent.</li>

          <li>Malware infections are commonplace through downloaded files that harbor viruses. These can corrupt devices and expose personal data if downloads aren't scanned.</li>

          <li>Locally saved downloads are vulnerable to hacking if devices are compromised. Hackers can steal sensitive download data by breaching computers and phones.</li>

          <li>Others may be able to view your downloading history if saved locally, exposing what sites you frequent and content interests. This enables prying eyes to snoop on your activities.</li>

          <li>Downloads consume local device storage space, leading to clutter and performance issues over time as capacity fills up.</li>

          <li>It's easy to misplace downloads when saved locally across scattered folders. Out of sight, out of mind. Forgotten downloads get buried quickly.</li>
        </ul>

        <p>Bypassing all these risks is crucial for your privacy, security, comfort, and for not losing that pesky file. Our cloud-based approach completely removes these threats by handling downloads on isolated servers instead.</p>
      </div>
      <div class="products-details-child paragraph grey">
        <h2>The Benefits of Cloud Downloading</h2>

        <p>With our service, your downloads occur securely on remote servers in the cloud, keeping personal devices protected:</p>

        <ul>
          <li>No local traces are left behind that could expose your privacy. Cloud downloads don't save to your hard drive.</li>

          <li>Files transfer seamlessly via encryption to your personal secure cloud storage instead of filling local device space.</li>

          <li>Our servers are isolated from the outside web, keeping downloads siloed from any external access.</li>

          <li>We implement robust security protections on our servers including firewalls, access controls, and encryption.</li>

          <li>You can access downloads remotely on any internet-connected device conveniently and securely. No need to transfer files across devices.</li>

          <li>Your organized content library on the Seedr cloud makes your files accessible anywhere, on all your devices - without consuming extra bandwidth.</li>

          <li>Cloud downloading also enables hands-free automated transfers. With files downloading remotely, the process continues even after you shut down your device or walk away. Our servers handle transfers persistently in the background without needing your constant monitoring.</li>
        </ul>
      </div>
      <div class="products-details-child paragraph grey">
        <h2>Greater Peace of Mind</h2>

        <p>Knowing your sensitive data stays protected and accessible gives much greater peace of mind. Our secure cloud downloading service provides:</p>

        <ul>
          <li>Complete confidentiality as your actions are kept private from start to finish. Our robust security measures protect your information every step.</li>

          <li>You also avoid cluttering your devices with unnecessary downloads, and can have a look at what's inside before moving it to your device.</li>

          <li>Got any issues? Our friendly customer support reps are available with extra priority to premium users for your complete satisfaction.</li>

          <li>Got multiple devices? Mobile access enables retrieving downloads on smartphones and tablets remotely. You can also just view them through our web interface! (Read more below).</li>
        </ul>

        <p>Our solution is designed for stress-free downloading, without worrying about privacy, security, or storage management.</p>
      </div>
      <div class="products-details-child paragraph grey">
        <h2>How Our Simple 3-Step Cloud Download Process Works</h2>

        <p>Our secure cloud download system keeps your information completely private:</p>

        <ol>

          <li>Browse the web and copy links to files you want per usual. No change in habits needed.</li>

          <li>Paste links into our platform to initiate transfers. Our servers handle the downloads instead of saving locally.</li>

          <li>Downloads complete remotely in the cloud. Your device remains protected without traces.</li>
        </ol>

        <p>Once finished, your files are privately stored in your encrypted cloud locker for anytime access. The process protects privacy while saving local device space.</p>
      </div>
      <div class="products-details-child paragraph grey">
        <h2>We Have the Credentials You Can Trust</h2>

        <p>With a decade of experience providing secure cloud services, you can trust us fully to keep your downloading activity and data safe.</p>

        <p>Our company has extensive experience providing solutions to customers like you. We utilize state-of-the-art data centers with hardened security and the high reliability.</p>

        <p>Your transfers are secured with robust 256-bit AES encryption with frequently updated protocols list. Our strict company policy is to not sell, share, or send your data to third parties, not even 3rd-party hosted tools.</p>

        <p>Highly rated and trusted, we aim to provide the best value, features, and support. Our friendly customer reps are available 24/7 by phone and email to ensure your lifelong satisfaction.</p>

        <p>Affordable plans allow choosing the right level of security for your needs and budget. Join millions of happy users today.</p>
      </div>
      <div class="products-details-child paragraph grey">
        <h2>Private Cloud Storage Included</h2>

        <p>Downloaded files are automatically stored in your private secure cloud storage.</p>

        <p>Our cloud infrastructure utilizes security measures like intrusion detection, access controls, and surveillance to prevent unauthorized access.</p>

        <p>We utilize multiple data centers to make sure your data is always available. This prevents any one location taking away access to your files.</p>

        <p>We aim to give you sole access and control over your locker. Our service enables convenient streaming and downloading, and we do not sell or share your data with third parties.</p>
      </div>
      <div class="products-details-child paragraph grey">
        <h2>Advanced Security Features</h2>

        <p>For added security, enable our advanced protective measures:</p>

        <ul>
          <li>Two-factor authentication requires entering a code from your phone when logging in for an extra layer of account protection.</li>

          <li>IP whitelisting allows only certain trusted IP addresses to access your account while blocking all others.</li>

          <li>Custom password creation enables changing your login credentials from the standard ones to unique ones of your choosing.</li>

          <li>Sessions automatically expire after a period of inactivity to reduce the chance of session hijacking.</li>
        </ul>

        <p>Take your cloud storage lockdown to the next level by implementing extra security controls like two-factor and IP whitelisting to customize protection.</p>
      </div>
      <div class="products-details-child paragraph grey">
        <h2>Download with Confidence</h2>

        <p>Our cloud-based service enables you to browse, download, and store files privately without any stress or worries. You can have full confidence your sensitive data is secure thanks to our multilayered privacy-centric approach.</p>

        <p>The multitude of benefits our platform provides are clear:</p>

        <ul>
          <li>Enhanced privacy as all your personal information stays protected in the cloud from end to end.</li>

          <li>Reduced risk from malware, tracking, snooping, and device clutter.</li>

          <li>Greater accessibility to retrieve downloads remotely on any device with internet access.</li>

          <li>More control to manage everything conveniently through our intuitive user interface.</li>

          <li>Complete security from encryption to infrastructure safeguards files.</li>

          <li>Constant support with priority customer service available to answer any question.</li>

          <li>Automated hands-free downloading in the background even after shutting down devices.</li>
        </ul>

        <p>Secure cloud downloading brings freedom and convenience. Start downloading stress-free today. Our solution is here to help protect your privacy with ease so that you can access content seamlessly.</p>

        <p>Don't waste another minute worrying about online privacy or security. Our service keeps your browsing and downloading safe using remote cloud servers. Regain peace of mind and take back your digital life. The future is one where technology protects people, not exploits them.</p>      </div>

      <div class="products-details-child cta">
        <span><a href="https://www.seedr.cc/pulse/">{{ $t('products-video.details.cta') }}</a></span>
      </div>
    </section>

    <section class="products-start-parent">
      <div class="products-start-child start-now-group">
        <h1>Get Stuff Quickly & Easily</h1>
        <SButton class="button-fill button-primary" btn-link="https://www.seedr.cc/premium" icon-font="s-icon-premium">Join Premium</SButton>
      </div>

      <div class="products-start-child advantages-group">
        <span class="advantages"><s-icon class="icon"  icon-font="s-icon-link"/>Paste a link from another website</span>
        <span class="advantages"><s-icon class="icon" icon-font="s-icon-clock-thick"/>Wait Few Seconds</span>
        <span class="advantages"><s-icon class="icon" icon-font="s-icon-download-line"/>Download & Stream on any device. Without Software</span>
      </div>
    </section>

    <section class="products-links-products">
      <h1>{{ $t('products.go-to-next-title') }} <span class="s-text-blue">feature</span></h1>
      <a class="" href="/products/streaming">
        <img src="/images/products_video_icon.svg" alt="icon">Stream Anywhere & Anytime
      </a>
      <a class="" href="/products/mobile">
        <img src="/images/products_mobile_icon.svg" alt="icon">Mobile Optimized
      </a>
      <a class="" href="/products/secure">
        <img src="/images/products_secure_icon.svg" alt="icon">Private and Secure
      </a>
    </section>

    <section class="products-faq">
      <div class="products-plans-questions">
        <h2>{{ $t('products.questions-title') }}</h2>
        <div class="products-plans-cta">

          <SButton class="button-secondary" btn-link="https://help.seedr.cc/hc/en-us">{{$t('actions.faq')}}</SButton>

          <SButton class="button-secondary" btn-link="https://help.seedr.cc/hc/en-us/requests/new">{{$t('actions.contact-us')}}</SButton>

        </div>
      </div>
    </section>
  </div>
</template>

<script>

export const documentProps = {
  title: 'Private, Secure, Yours: Download with Peace of Mind',
  description: 'Seedr is a fast, private cloud downloader and streaming service. Directly download files and torrents to our secure cloud servers. Stream videos, music, and more without downloading to your device. Access your cloud files from any device. Enjoy private downloading with no tracking or logs. Seedr keeps your browsing and downloads safe and secure in the cloud.',
  keywords: "cloud downloader, file downloader, magnet download, cloud magnet download, streaming, cloud storage, cloud-based file downloader, secure cloud file downloader, download torrents to cloud storage, stream videos from cloud storage, download large files to the cloud, cloud downloader for privacy, stream music from the cloud, cloud storage and streaming service"
}



import SButton from '/components/SButton.vue'
import SIcon from "/components/SIcon.vue";
export default {
  components: {
    SButton,
    SIcon,
  },
  data() {
    return {

    }
  }
}
</script>

<style scoped lang="scss">

.products {
  height: 86.6vh;
  display: flex;
  flex-direction: column;
  margin: auto auto;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>
